module.exports = __webpack_public_path__ + "img/distribution-revenue-icon.6e8b8be0.png";